import Actions from '../action'

const initialState = {
    isLoading: false,
    error: false,
    fabricList: [],
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_FABRIC_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GET_FABRIC_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                fabricList: action.data,
                error: false
            };
        }
        case Actions.GET_FABRIC_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        default:
            return state;
    }

};